/**
 * B639 (d) — the guided first-product chat's draft: the thread survives a
 * reload. ONE draft per TENANT (not per staff, unlike B98's staff.prefs) so
 * a Login-as visit and the tenant's own admin resume the same conversation.
 *
 * The body is the admin's serialized thread, carried as OPAQUE text (a JSON
 * object, bounded) — the server stores it and gives it back, nothing more;
 * a plan it describes still goes live only through the ordinary approve
 * path. Audience = the setup audience (MANAGER/ADMIN); both doors ride
 * catalog:read, the audience's own scope (the B98 staff.prefs.set
 * precedent — a dedicated scope would be an authorizer amendment). The
 * write is a full replacement; `null` clears it (after an approved run, or
 * a restart).
 */
import { z } from "zod";
import { readOp, writeOp } from "./common.js";

/** Mirrors the domain's MAX_SETUP_DRAFT_CHARS — the schema refuses before the store is asked. */
const MAX_DRAFT_CHARS = 64_000;

export const setupDraftGet = readOp({
  name: "setup.draft.get",
  permission: "catalog:read",
  principals: ["STAFF:MANAGER", "STAFF:ADMIN"],
  fields: {},
  response: z
    .object({
      draft: z.object({ conversation: z.string().min(1).max(MAX_DRAFT_CHARS), updatedAt: z.number().int().nonnegative() }).strict().optional(),
    })
    .strict(),
  exampleRequest: {},
  exampleResponse: { draft: { conversation: '{"v":1,"transcript":[]}', updatedAt: 1_780_000_000_000 } },
});

export const setupDraftSave = writeOp({
  name: "setup.draft.save",
  permission: "catalog:read",
  principals: ["STAFF:MANAGER", "STAFF:ADMIN"],
  fields: { conversation: z.string().min(1).max(MAX_DRAFT_CHARS).nullable() },
  /** `updatedAt` present = stored; absent = cleared (a `null` save). */
  response: z.object({ updatedAt: z.number().int().nonnegative().optional() }).strict(),
  exampleRequest: { conversation: '{"v":1,"transcript":[]}' },
  exampleResponse: { updatedAt: 1_780_000_000_000 },
});
